import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+model/table/dto_diffusion_models_table_page_settings_ud';
import { DTODiffusionModelsTableUD } from '@shared/dto/+model/table/dto_diffusion_models_table_ud';
import { StateMLAsset } from '../state_ml_asset';

export async function diffusion_models_ud_update_current_table_with_settings(state: StateMLAsset, table_page_settings: DTODiffusionModelsTablePageSettingsUD) {
  table_page_settings.assert_standard_fields();

  let hash_crc32_settings_table = table_page_settings.hash_create();

  let table = state.tables_map.get(hash_crc32_settings_table);

  if (!table) {
    //table not cached
    table = new DTODiffusionModelsTableUD();
    table.items_amount_by_type_all = 0;
    table.items_amount_by_base_model_all = 0;
    table.hash_crc32_settings_table = hash_crc32_settings_table;

    state.tables_map.set(hash_crc32_settings_table, table);

    //need to force re-render
    state.tables_map = new Map(state.tables_map);
  }

  state.current_table = table.clone();
}
